// extracted by mini-css-extract-plugin
export default {"legacyApiNote":"user-module__fh5cv"};